










































































































































































































































import { startsWith } from 'lodash';
import dateFormat from '@/utils/dateFormat';
import moment from 'moment';
import Vue, { PropType } from 'vue';
import { Day } from 'dayspan';
import {
  RRule,
  RRuleSet,
  rrulestr,
  Frequency,
  Options as RRuleOptions,
  Weekday
} from 'rrule';

function checkDate(x: Date | string): Date {
  if (typeof x === 'string') {
    return new Date(x);
  } else {
    return x;
  }
}

export function getDayOfWeek(x: Date, options = { weekStartsOn: 0 }): number {
  const { weekStartsOn } = options;
  const day = checkDate(x).getDay();

  return day < weekStartsOn ? day - weekStartsOn + 7 : day - weekStartsOn;
}
export type endChoice = 'until' | 'count' | 'never';

export default Vue.extend({
  props: {
    useActiviator: {
      type: Boolean,
      default: false
    },
    useSlot: Boolean
  },
  data() {
    return {
      dialog: false,
      resolve: null as any,
      reject: null as any,
      message: '',
      error: false,
      match: '',
      name: '',
      confirm: false,
      title: '',
      options: {
        'max-width': 400,
        zIndex: 200
      },
      buttonOptions: {
        text: false,
        left: {
          text: 'Cancel'
        },
        right: {
          color: 'primary',
          text: 'Continue',
          icon: null,
          iconOnly: false
        }
      },
      startDateMenu: false,
      startTimeMenu: false,
      endDateMenu: false,
      endTimeMenu: false,
      time: [],
      days: [
        RRule.SU,
        RRule.MO,
        RRule.TU,
        RRule.WE,
        RRule.TH,
        RRule.FR,
        RRule.SA
      ],
      iterationNumber: [1, 2, 3, 4],
      weekdays: [1, 2, 3, 4], //weekdays selected
      count: 1, // number of iterations
      useCountOrUntil: 'until' as endChoice,
      interval: 1, // intervals between iterations
      dtStart: new Date(),

      recurrenceRule: {
        freq: Frequency.WEEKLY,
        dtstart: new Day(new Date())
          .startOf('minute')
          .utc()
          .toDate(),
        interval: 1,
        wkst: null,
        count: 30,
        until: new Day(new Date())
          .utc()
          .add('day', 30)
          .toDate(),
        bysetpos: null,
        bymonth: null,
        bymonthday: null,
        bynmonthday: null,
        byyearday: null,
        byweekno: null,
        byweekday: [],
        bynweekday: null,
        byhour: null,
        byminute: null,
        bysecond: null,
        byeaster: null
      } as Partial<RRuleOptions>
    };
  },
  computed: {
    frequencies(): any[] {
      return [
        {
          text: this.recurrenceRule.interval! > 1 ? 'Days' : 'Day',
          value: Frequency.DAILY
        },
        {
          text: this.recurrenceRule.interval! > 1 ? 'Weeks' : 'Week',
          value: Frequency.WEEKLY
        },
        {
          text: this.recurrenceRule.interval! > 1 ? 'Months' : 'Month',
          value: Frequency.MONTHLY
        },
        {
          text: this.recurrenceRule.interval! > 1 ? 'Years' : 'Year',
          value: Frequency.YEARLY
        }
      ];
    },
    Frequency: () => Frequency
  },
  methods: {
    dateFormat,

    computedRules(rules: string[]): string[] {
      return rules.filter(
        (e: string) => startsWith(e, 'RR') || !startsWith(e, 'DT')
      );
    },
    open(options: { rule: string[]; start: Date }) {
      this.dialog = true;
      const { rule, start } = options;
      this.dtStart = start;
      if (!rule.length) {
        this.recurrenceRule = this.getDefaultRuleOptions();
        if (this.recurrenceRule.freq === Frequency.WEEKLY) {
          (this.recurrenceRule.byweekday as number[]).push(
            new Weekday(getDayOfWeek(this.dtStart, { weekStartsOn: 1 })).weekday
          );
        }

        this.useCountOrUntil = 'count';
      } else {
        this.computedRules(rule).forEach((element: string) => {
          const rule = RRule.fromString(element);
          this.recurrenceRule = rule.options;

          if (rule.options.count) {
            this.useCountOrUntil = 'count';
          } else if (rule.options.until) {
            this.useCountOrUntil = 'until';
          } else {
            this.useCountOrUntil = 'never';
          }
        });
      }
    },

    async agree() {
      let patterns: Partial<RRuleOptions> = {
        ...this.recurrenceRule
      };
      patterns = this.parseRRule(patterns);

      switch (this.useCountOrUntil) {
        case 'never':
          patterns['until'] = null;
          patterns['count'] = null;
          break;
        case 'until':
          patterns['until'] = this.recurrenceRule.until;
          patterns['count'] = null;
          break;
        case 'count':
          patterns['count'] = this.recurrenceRule.count;
          patterns['until'] = null;
          break;
        default:
          patterns['count'] = null;
          patterns['until'] = null;
          break;
      }
      await this.$emit('saved', patterns);
      this.finishClose();
    },
    finishClose() {
      this.dialog = false;
      this.recurrenceRule = this.getDefaultRuleOptions();
    },
    cancel() {
      this.dialog = false;
    },

    getDefaultRuleOptions(): Partial<RRuleOptions> {
      return {
        freq: Frequency.WEEKLY,
        dtstart: new Day(new Date(this.dtStart))
          .startOf('minute')
          .utc()
          .toDate(),
        interval: 1,
        wkst: null,
        count: 30,
        until: new Day(new Date(this.dtStart))
          .utc()
          .add('day', 30)
          .toDate(),
        bysetpos: null,
        bymonth: null,
        bymonthday: null,
        bynmonthday: null,
        byyearday: null,
        byweekno: null,
        byweekday: [],
        bynweekday: null,
        byhour: null,
        byminute: null,
        bysecond: null,
        byeaster: null
      };
    },
    parseRRule(rule: Partial<RRuleOptions>): Partial<RRuleOptions> {
      if (rule.freq !== Frequency.WEEKLY) {
        rule.byweekday = [];
      }
      return rule;
    }
  },
  mounted() {},
  watch: {
    dialog(newDial, oldDial) {
      if (!newDial) {
        this.finishClose();
      }
    },
    recurrenceRule: {
      handler(mutated: RRuleOptions, oldDial: RRuleOptions) {
        console.log({ mutated });
      },
      deep: true
    }
  },
  created() {}
});
